<!-- <ng-template #dialog>
    <h2 mat-dialog-title>Atualizar JSON</h2>
    <mat-dialog-content class="mat-typography">
        <h3>Atualizar JSON</h3>
        <textarea [formControl]="jsonControl" id="json-input" cols="50" rows="15"></textarea>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Salvar</button>
    </mat-dialog-actions>
</ng-template> -->
<div class="container py-2">
  <mat-card class="example-card">
    <!-- <mat-card-header>
            <div class="row mb-1">
                <div class="col py-1">
                    <label for="resize-input" class="form-label">Largura do quadro (1-12)</label>
                    <input [formControl]="widthControl" type="number" class="form-control" name="resize-input" id="resize-input" min="1" max="12">
                </div>
            </div>
        </mat-card-header> -->
    <mat-card-content>
      <div class="row">
        <div [ngClass]="div_class" style="background-color: null" #screen>
          <div class="table-title">
            <b>{{ data.title }}</b>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-borderless mb-0">
              <thead class="rounded-0">
                <tr>
                  <th
                    scope="col"
                    class="py-1"
                    *ngFor="let item of data.header"
                    [innerHTML]="item"
                  ></th>
                </tr>
              </thead>
              <tbody id="table-body">
                <tr *ngFor="let row of data.rows">
                  <td *ngFor="let item of row" [innerHTML]="item"></td>
                </tr>
              </tbody>
              <tfoot id="table-footer" class="rounded-0">
                <tr>
                  <th
                    scope="col"
                    class="py-1"
                    *ngFor="let item of data.footer"
                    [innerHTML]="item"
                  ></th>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-borderless mb-0">
              <thead id="table-legend" class="rounded-0">
                <tr>
                  <td class="small mx-1 my-2"><b>Fonte: </b>Sumé Software</td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </mat-card-content>
    <!-- <mat-card-actions>
            <button mat-button (click)="downloadImage(data.title)" type="button" color="primary"><i class="fa fa-save"></i></button>
            <button mat-button (click)="openDialog()" color="primary"><i class="fa fa-pencil-alt"></i></button>
        </mat-card-actions> -->
  </mat-card>
</div>
